module.exports = __webpack_public_path__ + "static/img/manual-15.3c84a87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-15.png
// module id = uYnE
// module chunks = 4